<div class="card">
  <div class="card-header">
    <div class="card-title mb-0">
      {{ 'RESIDENTS.RENTER_INFORMATION' | translate }}
    </div>

    <!--    @if (residentInformation) {-->
    <!--      <button type="button" class="btn btn-sm btn-danger" (click)="withdraw()">-->
    <!--        <i class="la la-arrow-down mr-1"></i>-->
    <!--        {{ 'RESIDENTS.UNASSIGN' | translate }}-->
    <!--      </button>-->
    <!--    } @else {-->
    <!--      <button type="button" class="btn btn-sm btn-primary" (click)="assign()">-->
    <!--        <i class="la la-sync mr-1"></i>-->
    <!--        {{ 'RESIDENTS.ASSIGN' | translate }}-->
    <!--      </button>-->
    <!--    }-->
  </div>

  <div class="card-body">
    @if (renterInformation) {
      <div class="info-line">
        <div class="icon-label">
          <i class="la la-user me-2"></i>
          <strong>{{ 'RESIDENTS.FULL_NAME' | translate }}:</strong>
        </div>
        <span>{{ renterInformation.fullName }}</span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="la la-id-card me-2"></i>
          <strong>{{ 'RESIDENTS.ID_CARD' | translate }}:</strong>
        </div>
        <span>{{ renterInformation.idCard }}</span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="la la-file-invoice-dollar me-2"></i>
          <strong>{{ 'RESIDENTS.TAX_CODE' | translate }}:</strong>
        </div>
        <span>{{ renterInformation.taxCode }}</span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="la la-envelope me-2"></i>
          <strong>{{ 'RESIDENTS.EMAIL' | translate }}</strong>
        </div>
        <span>{{ renterInformation.email }}</span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="la la-phone me-2"></i>
          <strong>{{ 'RESIDENTS.PHONE' | translate }}</strong>
        </div>
        <span>{{ renterInformation.phone }}</span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="la la-user-tag me-2"></i>
          <strong>{{ 'RESIDENTS.SOCIAL_STATUS' | translate }}:</strong>
        </div>
        <span>
        <span class="badge bg-primary">
          {{ renterInformation.socialStatus | titlecase }}
        </span>
      </span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="la la-birthday-cake me-2"></i>
          <strong>{{ 'RESIDENTS.BIRTH_DATE' | translate }}:</strong>
        </div>
        <span>{{ renterInformation.birthDate | date }}</span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="la la-credit-card me-2"></i>
          <strong>{{ 'RESIDENTS.ACCOUNT_NO' | translate }}:</strong>
        </div>
        <span>{{ renterInformation.accountNo }}</span>
      </div>

      <div class="info-line">
        <div class="icon-label">
          <i class="la la-home me-2"></i>
          <strong>{{ 'RESIDENTS.RENT_TYPE' | translate }}</strong>
        </div>
        <span>{{ 'RENT_TYPES.' + renterInformation.rentType|translate }}</span>
      </div>
    } @else {

      <div class="d-flex justify-content-center align-items-center" [style.height.px]="240">
        <img src="assets/images/{{'vacant-img'|translate}}" height="120" alt="image">
      </div>
    }
  </div>
</div>
